import { Link } from "react-router-dom";
import { MapPin, TrendingUp, ArrowUpRight } from "lucide-react";
import { PageShell } from "../components/PageShell";
import { PageHero } from "../components/PageHero";
import { YieldDisclaimer } from "../components/YieldDisclaimer";
import { PROJECTS } from "../data/site";

export default function ProjectsPage() {
  return (
    <PageShell>
      <PageHero
        eyebrow="Featured Portfolios"
        title="Handpicked Dubai"
        italic="opportunities"
        subtitle="Every listing is verified by our in-house investment desk. Estimated gross rental yields shown are indicative — actual net returns vary."
      />

      <section className="py-16 md:py-24 px-6 md:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-testid="projects-grid">
            {PROJECTS.map((p) => (
              <article
                key={p.id}
                className="group glass rounded-2xl overflow-hidden flex flex-col hover:border-[#c5a059]/40 transition-all"
                data-testid={`project-card-${p.id}`}
              >
                <div className="relative h-64 overflow-hidden">
                  <img src={p.image} alt={p.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#050a18] via-transparent to-transparent" />
                  <div className="absolute top-4 left-4 px-3 py-1 glass-strong rounded-full text-[10px] tracking-[0.25em] uppercase text-[#c5a059]">{p.developer}</div>
                  <div className="absolute bottom-4 right-4 flex items-center gap-1 text-[11px] text-white/80 bg-black/40 backdrop-blur px-3 py-1 rounded-full">
                    <MapPin size={11} /> {p.location.split(",")[0]}
                  </div>
                </div>

                <div className="p-6 flex flex-col flex-1">
                  <h3 className="font-serif-display text-2xl mb-1">{p.name}</h3>
                  <p className="text-white/50 italic text-sm mb-4">{p.tag}</p>

                  <div className="grid grid-cols-3 gap-2 mb-4 text-center">
                    <div className="border-r border-white/10">
                      <div className="text-[9px] tracking-[0.2em] text-white/40 uppercase mb-1">Est. Yield</div>
                      <div className="text-green-400 font-semibold flex items-center justify-center gap-1 text-sm">
                        <TrendingUp size={12} /> {p.yield}
                      </div>
                    </div>
                    <div className="border-r border-white/10">
                      <div className="text-[9px] tracking-[0.2em] text-white/40 uppercase mb-1">From</div>
                      <div className="text-[#c5a059] font-semibold text-sm">{p.price}</div>
                    </div>
                    <div>
                      <div className="text-[9px] tracking-[0.2em] text-white/40 uppercase mb-1">Handover</div>
                      <div className="text-white/85 font-semibold text-sm">{p.handover}</div>
                    </div>
                  </div>

                  <YieldDisclaimer className="mb-4" />

                  <Link
                    to={`/projects/${p.id}`}
                    className="mt-auto btn-outline-gold rounded-sm py-3 text-[11px] tracking-[0.3em] font-bold flex items-center justify-center gap-2"
                    data-testid={`view-${p.id}`}
                  >
                    VIEW DETAILS <ArrowUpRight size={14} />
                  </Link>
                </div>
              </article>
            ))}
          </div>

          <div className="mt-14">
            <YieldDisclaimer variant="global" />
          </div>
        </div>
      </section>
    </PageShell>
  );
}
